// interfaces/types
import { FeatureTogglesAndUrlOnly, IUrlOnlyFeatureToggles } from './featureToggleTypes';

export interface IGlobalConfig {
    featureToggles: IUrlOnlyFeatureToggles;
}

export const globalConfig = (): IGlobalConfig => {
    const result = (window as any).drs__SpGlobalConfig || {};
    return result;
};

export function isP202RedesignEnabled(): boolean {
    const featureToggles = (globalConfig().featureToggles as FeatureTogglesAndUrlOnly) || {};
    return featureToggles.enableP202Redesign;
}

export const isGhostVinEnabled = () => {
    const featureToggles = (globalConfig().featureToggles as FeatureTogglesAndUrlOnly) || {};
    return featureToggles.enableGhostVinDealer || false;
};

export const isAmdLienPayoffQuoteSpOnSPEnabled = (): boolean => {
    const featureToggles = (globalConfig().featureToggles as FeatureTogglesAndUrlOnly) || {};
    return featureToggles.amd_lien_payoff_quote_sp || false;
};

const featureToggles = {
    isP202RedesignEnabled,
    isGhostVinEnabled,
    isAmdLienPayoffQuoteSpOnSPEnabled
};

export default featureToggles;
